import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GtdGlobeService, GtdIncident } from '../../../../core/services/gtd-globe.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-gtd-incident-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gtd-incident-modal.component.html',
  styleUrl: './gtd-incident-modal.component.css',
})
export class GtdIncidentModalComponent {
  selectedIncident$: Observable<GtdIncident | null>;

  constructor(public gtdService: GtdGlobeService) {
    this.selectedIncident$ = this.gtdService.selectedIncident$;
  }

  close(): void {
    this.gtdService.closeIncidentModal();
  }

  flyToIncident(incident: GtdIncident): void {
    this.gtdService.flyToIncident(incident);
  }

  flyToState(state: string): void {
    this.gtdService.flyToState(state);
  }
}
